import styled from '@emotion/styled';
import GlobalNavButtonItem from '../../components/GlobalNavItems/GlobalNavButtonItem';
import { getPartnerLink } from '../../utils/getPartnerLink';
import { useEnvContext } from '../../../modules/EnvProvider';
import { getSigninWebLink } from '../../utils/getSigninWebLink';
import GlobalNavRoundButton from './GlobalNavRoundButton';

export default function LoggedOutItems() {
  const { targetEnv } = useEnvContext();

  return (
    <Container>
      <GlobalNavButtonItem
        type="link"
        label="파트너 로그인"
        pathname={`${getPartnerLink('/signIn', targetEnv)}`}
      />
      <GlobalNavRoundButton
        label="로그인 및 회원가입"
        pathname={() => getSigninWebLink(targetEnv)}
      />
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  height: 40px;
  > :not(:last-child) {
    margin-right: 8px;
  }
  button {
    line-height: inherit;
  }
`;
